import type { ReactNode } from "react";

import { Link, useSearchParams } from "react-router";

type InviteLinkProps = {
  to: string;
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const InviteLink = ({ to, children, className, style }: InviteLinkProps) => {
  const [, setSearchParams] = useSearchParams();

  if (to.startsWith("?")) {
    const query = new URLSearchParams(to.slice(1));
    return (
      <a
        href={to}
        className={className}
        style={style}
        onClick={(event) => {
          event.preventDefault();
          setSearchParams((prev) => {
            query.forEach((value, key) => {
              prev.set(key, value);
            });
            return prev;
          });
        }}
      >
        {children}
      </a>
    );
  }

  return (
    <Link className={className} style={style} to={to}>
      {children}
    </Link>
  );
};

export default InviteLink;
